import { Platform } from 'react-native';

export interface ShareFileOptions {
    uri: string;
    mimeType?: string | null | undefined;
}

export interface ShareFileResult {
    success: boolean;
    error?: string;
}

async function loadSharing(): Promise<any | null> {
    try {
        // Prefer native expo-sharing if installed
        const Sharing = await import('expo-sharing');
        return Sharing;
    } catch {
        return null;
    }
}

/**
 * Wrapper for expo-sharing to centralize error handling and platform guards.
 */
export async function shareFile(options: ShareFileOptions): Promise<ShareFileResult> {
    if (Platform.OS === 'web') {
        return { success: false, error: 'Sharing is not supported on web' };
    }

    const Sharing = await loadSharing();
    if (!Sharing) {
        // Fallback to React Native Share API
        const { Share } = await import('react-native');
        try {
            await Share.share(
                { url: options.uri, message: undefined },
                { dialogTitle: 'Share file' }
            );
            return { success: true };
        } catch (error: any) {
            return { success: false, error: error?.message || 'Failed to share file' };
        }
    }

    const available = await Sharing.isAvailableAsync();
    if (!available) {
        return { success: false, error: 'Sharing is not available on this device' };
    }

    try {
        await Sharing.shareAsync(options.uri, {
            mimeType: options.mimeType ?? undefined,
        });
        return { success: true };
    } catch (error: any) {
        return { success: false, error: error?.message || 'Failed to share file' };
    }
}

